import { useContext } from 'react'
import { IDnDStageMappingContext } from '../interfaces'
import { DnDStageMappingContext } from '../context/DnDStageMapping.context'

/**
 * Custom hook to use the DnD Stage Mapping context
 * Throws an error if used outside of DnDStageMappingProvider
 */
export const useDnDStageMappingContext = (): IDnDStageMappingContext => {
   const context = useContext(DnDStageMappingContext)

   if (context === undefined) {
      throw new Error(
         'useDnDStageMapping must be used within a DnDStageMappingProvider'
      )
   }

   return context
}
